import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AlertService } from 'src/app/_services/alert.service';
import { MenusService } from 'src/app/_services/menu.service';

@Component({
  selector: 'app-ledger-only',
  templateUrl: './ledger-only.component.html',
  styleUrls: ['./ledger-only.component.scss']
})
export class LedgerOnlyComponent implements OnInit {



  public permissions: string = '';
  constructor(private alertService: AlertService, private location: Location, private router: Router, private menuService: MenusService) { }

  async ngOnInit(): Promise<void> {
    const path = this.location.prepareExternalUrl(this.location.path());
    this.permissions = this.menuService.getPermissions(path);
    if (this.permissions == null || this.permissions == '' || !this.permissions) {
      this.alertService.errorAlert({
        title: "No Access",
        backdrop: true,
        toast: true,
        timer: 1500
      })
      await this.router.navigateByUrl('/');
    }
  }

}
